import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { MtxMomentDatetimeModule } from '@ng-matero/extensions-moment-adapter';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YY',
    monthInput: 'MMMM',
    yearInput: 'YYYY',
    timeInput: 'HH:mm',
    datetimeInput: 'DD-MM-YY HH:mm',
  },
  display: {
    dateInput: 'DD-MM-YY',
    monthInput: 'MMMM',
    yearInput: 'YYYY',
    timeInput: 'HH:mm',
    datetimeInput: 'DD-MM-YY HH:mm',
    monthYearLabel: 'YYYY MMMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    popupHeaderDateLabel: 'MMM DD, ddd',
  },
};

@NgModule({
  imports: [
    CommonModule,
    MtxMomentDatetimeModule,
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'nl-NL'
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MTX_DATETIME_FORMATS,
      useValue: MY_DATE_FORMATS,
    },
  ],
})
export class FurySharedDateModule {
  static forRoot() {
    return {
      ngModule: FurySharedDateModule,
      providers: [
        {
          provide: MAT_DATE_LOCALE,
          useValue: 'nl-NL'
        },
        {
          provide: MAT_DATE_FORMATS,
          useValue: MY_DATE_FORMATS
        },
        {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
          provide: MTX_DATETIME_FORMATS,
          useValue: MY_DATE_FORMATS,
        },
      ]
    };
  }
}
